import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  loadingCircular: {
    position: 'absolute',
    left: '50%',
    top: '50%'
  }
}));
